import React, { useState, useMemo, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const LoginContext = createContext();

function LoginProvider({ children, initialEmail = '', initialError }) {
  const [signInStep, setSignInStep] = useState(null);
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState('');
  const [qrCodeImage, setQrCodeImage] = useState('');
  const [secretCode, setSecretCode] = useState('');
  const [userCode, setUserCode] = useState('');
  const [error, setError] = useState(initialError ?? undefined);

  return (
    <LoginContext.Provider
      value={useMemo(
        () => ({
          signInStep,
          setSignInStep,
          email,
          setEmail,
          password,
          setPassword,
          qrCodeImage,
          setQrCodeImage,
          secretCode,
          setSecretCode,
          userCode,
          setUserCode,
          error,
          setError,
        }),
        [
          signInStep,
          setSignInStep,
          email,
          setEmail,
          password,
          setPassword,
          qrCodeImage,
          setQrCodeImage,
          secretCode,
          setSecretCode,
          userCode,
          setUserCode,
          error,
          setError,
        ],
      )}
    >
      {children}
    </LoginContext.Provider>
  );
}

function useLoginContext() {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('Context is not initialised');
  }
  return context;
}

LoginProvider.propTypes = {
  children: PropTypes.element,
  initialEmail: PropTypes.string,
  initialError: PropTypes.string,
};

export { LoginProvider, useLoginContext };
